// Copy for the shift-request missing-info modal. The shell copy is quoted from Figma
// IRnR1z98UraThG8BdvffK7 node 7020:74310; the field labels have no design of their own.
// Mirrored verbatim in TempMee/mobile-app — change both together.

export const OFFICE_MISSING_INFO_COPY = {
  title: 'Your account is missing a few details',
  description:
    'These help your shifts get noticed by pros. Add them before you post your next shift.',
  save: 'Save',
  saveError: "We couldn't save your details. Please try again.",
  timePerPatient: {
    overline: 'Time per patient',
    helper:
      'We track this for every role at every location, whether or not you book pros for that role.',
  },
  assistedHygiene: {
    overline: 'Assisted hygiene',
    helper: 'Is assisted hygiene available at your office for temp hygienists?',
    label: 'Assisted hygiene',
  },
  parking: {
    overline: 'Parking',
    typeLabel: 'Parking type',
    isFreeLabel: 'Is parking free?',
    costLabel: 'Parking cost',
    costUnitLabel: 'Cost unit',
  },
  softwares: {
    overline: 'Office software',
  },
  insurances: {
    overline: 'Insurance type',
  },
  operatories: {
    overline: 'Number of operatories',
    label: '# of operatories',
  },
} as const;
